import { apiSlice } from '../../../../app/apiSlice';
import { Noticia, NoticiaDTO, NoticiaList } from '../../../../typesSite/noticia/Noticia';
import { NoticiaAnexo } from '../../../../typesSite/noticia/NoticiaAnexo';

import configSiteUrls from '../../configs/configSiteUrls';
//usei o noticia como base

const endpointUrl = configSiteUrls.SITE_NOTICIA_EP;
const endpointUrlPublic = configSiteUrls.SITE_NOTICIA_PUBLIC_EP;

function getNoticiaAnexos({ idNoticia }: { idNoticia: string }) {
  if (!idNoticia) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrl}/anexos?idn=${idNoticia}`,
    method: 'GET'
  };
}
function getNoticiaAnexosPublic({ idNoticia }: { idNoticia: string }) {
  if (!idNoticia) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idNoticia}`,
    method: 'GET'
  };
}

function addAnexos(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function addCapa(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/capa`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function removeAnexosExcluidos(formData: FormData) {
  return {
    url: `${endpointUrl}/remover-anexos`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}


/*
function getNoticiaAnexoDownload({ ida }: { ida: string }) {
  if (!ida) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointUrlPublic}/anexo/download?ida=${ida}&tipo=NOTICIA`,
    method: 'GET',
    meta: { responseType: 'blob' },
  };
}*/

export const noticiaAnexoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getNoticiaAnexos: query<NoticiaAnexo[], { idNoticia: string }>({
      query: getNoticiaAnexos,
      providesTags: ['NoticiaAnexoSite']
    }),
    getNoticiaAnexosPublic: query<NoticiaAnexo[], { idNoticia: string }>({
      query: getNoticiaAnexosPublic,
      providesTags: ['NoticiaAnexoSite']
    }),
   
   /* getNoticiaAnexoDownload: query<Blob, { ida: string }>({
      query: getNoticiaAnexoDownload,
      transformResponse: async (response: Response) => {
        return await response.blob();
      },
      providesTags: ['NoticiaAnexoSite']
    }),*/
    addNoticiaAnexos: mutation<void, FormData>({
      query: addAnexos,
      invalidatesTags: ['NoticiaAnexoSite']
    }),
    addNoticiaCapa: mutation<void, FormData>({
      query: addCapa,
      invalidatesTags: ['NoticiaAnexoSite']
    }),
    removeNoticiaAnexoExcluido: mutation<void, FormData>({
      query: removeAnexosExcluidos,
      invalidatesTags: ['NoticiaAnexoSite']
    })
  })
});
export const {
  useGetNoticiaAnexosQuery,
  useGetNoticiaAnexosPublicQuery,
  useAddNoticiaAnexosMutation,
  useAddNoticiaCapaMutation,
  useRemoveNoticiaAnexoExcluidoMutation,
 // useGetNoticiaAnexoDownloadQuery,
  //useLazyGetNoticiaAnexoDownloadQuery
} = noticiaAnexoApiSlice;
